var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute"},style:({
		left: ((_vm.position.left + 2) + "%"),
		top: ((_vm.position.top + 6) + "%"),
	})},[_c('div',{staticClass:"badge badge-light",staticStyle:{"width":"40px"}},[_vm._v("\t\n\t\t"+_vm._s(_vm.step === 0 ? 'Start' : _vm.step)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }